import React, { useState, useRef, useEffect } from 'react';

const ChatModal = ({ isOpen, onClose }) => {
  const [messages, setMessages] = useState([
    { id: 1, text: 'Hello! How can I assist you today?', type: 'bot' }
  ]);
  const [inputMessage, setInputMessage] = useState('');
  const chatBodyRef = useRef(null);
  const textareaRef = useRef(null);

  useEffect(() => {
    if (isOpen && textareaRef.current) {
      textareaRef.current.focus();
    }
    if (isOpen && chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  }, [isOpen]);

  const handleSendMessage = () => {
    if (inputMessage.trim()) {
      const newMessage = {
        id: messages.length + 1,
        text: inputMessage.trim(),
        type: 'user'
      };
      
      setMessages(prev => [...prev, newMessage]);
      setInputMessage('');
      
      // Reset textarea height
      if (textareaRef.current) {
        textareaRef.current.style.height = '48px';
      }

      // Simulate bot response
      setTimeout(() => {
        const botResponse = {
          id: messages.length + 2,
          text: 'Thank you for contacting us! We will get back to you shortly.',
          type: 'bot'
        };
        setMessages(prev => [...prev, botResponse]);
      }, 1000);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handleInputChange = (e) => {
    setInputMessage(e.target.value);
    
    // Auto-resize textarea
    e.target.style.height = 'auto';
    e.target.style.height = (e.target.scrollHeight) + 'px';
  };

  if (!isOpen) return null;

  return (
    <div 
      className={`chat-modal ${isOpen ? 'active' : ''}`} 
      role="dialog" 
      aria-modal="true" 
      aria-labelledby="chatModalTitle"
    >
      <div className="chat-modal-header">
        <h3 id="chatModalTitle">Contact Support</h3>
        <button 
          className="chat-modal-close" 
          onClick={onClose}
          aria-label="Close chat"
        >
          <i className="fas fa-times"></i>
        </button>
      </div>
      
      <div className="chat-modal-body" ref={chatBodyRef}>
        {messages.map((message) => (
          <div 
            key={message.id} 
            className={`chat-message ${message.type}`}
          >
            {message.text}
          </div>
        ))}
      </div>
      
      <div className="chat-modal-footer">
        <textarea
          ref={textareaRef}
          id="chatInput"
          placeholder="Type your question..."
          aria-label="Your message"
          value={inputMessage}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          rows="1"
        />
        <button 
          id="chatSendButton"
          onClick={handleSendMessage}
          aria-label="Send message"
          disabled={!inputMessage.trim()}
        >
          <i className="fas fa-paper-plane"></i>
        </button>
      </div>
    </div>
  );
};

export default ChatModal;